import React from 'react';
import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';

export const ReelCircle = styled.div`
    position: absolute;
    top: ${({ theme }) => theme.card.overlayPaddingTopBottom};
    right: ${({ theme }) => theme.card.overlayPaddingLeftRight};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    background: ${COLORS.liveYellow};
    border-radius: 50%;
    z-index: 1;
`;

const ReelTick = styled.div`
    width: 12px;
    height: 6px;
    transform: rotate(-45deg);
    border-left: 2px solid ${COLORS.mlbGrey8};
    border-bottom: 2px solid ${COLORS.mlbGrey8};
    margin-bottom: 4px;
    box-sizing: content-box;
`;

const ReelCheck = () => (
    <ReelCircle>
        <ReelTick/>
    </ReelCircle>
);

export default ReelCheck;
